<template>
	<div class="starter-page tw-pb-8 tw-bg-purple-100">
		<b-jumbotron
			text-variant="white"
			border-variant="light"
			bg-variant="gradient-blue"
			class="tw-rounded-none tw-rounded-b-md tw-border-none"
		>
			<template #header>EasyVal</template>

			<template #lead>
				Certificamos el Valor en un CLICk!
			</template>

			<hr class="my-3" />

			<div class="tw-mb-4">
				Nos apoyamos de la tecnología y la experiencia de campo, para crear una
				herramienta que agilice y optimice sus recursos mejorando la
				administración de sus avalúos y proveedores.
			</div>
		</b-jumbotron>

		<b-container
			fluid
			class="mt--7"
		>
			<b-row>
				<b-col>
					<b-card
						no-body
						class="border-0"
					>
						<img
							class="img-fluid tw-rounded-md tw-shadow-2xl"
							src="../assets/slide1.png"
							alt="Responsive image"
						/>
					</b-card>
				</b-col>
			</b-row>
		</b-container>

		<!-- <b-carousel
    id="carousel-fade"
    style="text-shadow: 0px 0px 2px #000"
    fade
    indicators
    img-width="1024"
    img-height="480"
  >
    <b-carousel-slide
      caption=""
       img-src="https://www.dropbox.com/s/dfxfoas5e0q42h1/slide3.png?dl=0"
    > </b-carousel-slide>
    <b-carousel-slide
      caption=""
      img-src="~assets/slide2.png"
    ></b-carousel-slide>
    <b-carousel-slide
      caption=""
      img-src=""
    ></b-carousel-slide>
  </b-carousel> -->
	</div>
</template>
<script>
export default {
	name: "inicio",
	components: {},
	data() {
		return {};
	}
};
</script>
<style>
	.starter-page {
		min-height: calc(100vh - 380px);
	}
</style>
